import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";
import {StringBuilder} from "../../AppUtils.js";

export const updateBudgetTransactionAdminComment = async (order, adminComment, errorMessage, successMessage) => {
    const response = await HttpClient.safePost(
        `/admin/api/updateBudgetTransactionAdminComment/${order.eventId}`,
        adminComment
    );

    if (response?.error) {
        message.error(new StringBuilder(errorMessage, "|").append(response?.error).toString());
    } else {
        message.success(successMessage);
    }
    return response;
};
